import React from 'react';
import PropTypes from 'prop-types';
import ExternalLinkIcon from './icons/ExternalLinkIcon';
const ExternalLink = ({ title, children, href, showIcon, dataTestId }) => {
    return ((React.createElement("a", { "data-testid": dataTestId, className: "", title: title, href: href, target: "_blank", rel: "noopener noreferrer" },
        React.createElement("div", { "data-testid": "div-a03404cc", className: "flex items-center space-x-1" },
            React.createElement("span", { "data-testid": "span-257eacba" }, children || title),
            showIcon ? (React.createElement(ExternalLinkIcon, { className: "w-4 h-4 flex-shrink-0" })) : null))));
};
ExternalLink.propTypes = {
    title: PropTypes.string,
    children: PropTypes.node,
    href: PropTypes.string,
    showIcon: PropTypes.bool,
};
ExternalLink.defaultProps = {
    showIcon: true,
};
export default ExternalLink;
